import { useEffect, useState } from "react";
import { useMarketingStore } from "@/zustand/emailMarketingStore.js";
import { useProductData } from "@/zustand/productStore.js";
import { ClockIcon, TruckIcon } from "@/utils/miscIcons";
import Timer from "@/components/Timer";
import DoubleTagIcon from "@/public/fallbacks/DoubleTagIcon.svg";

const Bars = ({ isProductHeroActive }) => {
  const { freeShippingEnabled, freeShippingApplied, remainingTime } = useMarketingStore();
  const productData = useProductData();

  const content = window.post_template.checkout_v4_meta_bars;
  const onlyLabel = content.tr_checkout_v4_meta_bars_only_label;
  const itemLabel = content.tr_checkout_v4_meta_bars_itemsLabel;
  const leftInStock = content.tr_checkout_v4_meta_bars_leftInStock_label;
  const productPickerV2 = productData?.show_product_picker_v2;
  const activeBars = content.checkout_v4_active_meta_bars;

  const [totalSupply, setTotalSupply] = useState();
  const [numberOfItems, setNumberOfItems] = useState();

  const timeRangeFrom = 20;
  const timeRangeTo = 30;
  const randomTotalSupply = Math.floor(Math.random() * 100 + 400);
  const randomCurrentStock = Math.floor(Math.random() * (107 - 95) + 95);
  const randomInterval = getRandomTime(timeRangeFrom, timeRangeTo);

  let startIncrement;
  const percents = calculatePercentageDecrease(numberOfItems, totalSupply);

  useEffect(() => {
    setTotalSupply(randomTotalSupply);
    setNumberOfItems(randomCurrentStock);
    startIncrement = setInterval(simulateIncrement, randomInterval * 1000);
  }, []);

  function getRandomTime(min, max) {
    return Math.floor(Math.random() * (Number(max) - Number(min))) + Number(min);
  }

  async function simulateIncrement() {
    const randomNumber = Math.floor(Math.random() * (9 - 7)) + 7;
    setNumberOfItems((prevNumberOfItems) => {
      if (prevNumberOfItems <= 5 || prevNumberOfItems - randomNumber <= 5) {
        clearInterval(startIncrement);
        return 5;
      } else {
        return Math.max(prevNumberOfItems - randomNumber);
      }
    });
  }

  function calculatePercentageDecrease(numberOfItems, totalSupply) {
    const newPercentage = (numberOfItems * 100) / totalSupply;
    return 100 - newPercentage;
  }

  return (
    <div
      className={`bars__container ${productPickerV2 && "bars__container--productPickerV2"} ${isProductHeroActive && "bars__container--productHero"}`}
    >
      {activeBars.map((bar) => {
        if (bar === "stock") {
          return (
            <div key="stock" className="bars__bar_1">
              <div className="bars__bar_1_leftText">
                {onlyLabel} <span className="bars__bar_1_leftText_red">{numberOfItems}</span> {itemLabel}
              </div>
              <span className="bars__bar_1__colorBar">
                <span className={`bars__bar_1__colorBar_colored `} style={{ width: `${percents}%` }}></span>
              </span>
              <div className="bars__bar_1_rightText">{leftInStock}</div>
            </div>
          );
        }
        if (bar === "offer") {
          return (
            <div key="offer" className="bars__bar_2">
              <img src={DoubleTagIcon} height={19} width={19} />
              <span>{content.tr_checkout_v4_meta_bars_discountBarLabel}</span>
            </div>
          );
        }
        if (bar === "timer") {
          return (
            <div key="timer" className="bars__bar_3">
              <ClockIcon />
              <span className="bars__bar_3_clockLabel">
                {content?.tr_checkout_v4_meta_bars_timeRemainingBarLabel.split("xx:xx")[0]}
                <span className="bars__bar_3_clockTime">
                  <Timer time={content.checkout_v4_meta_bars_timeRemainingBar_time ?? 10} />
                </span>
                {content.tr_checkout_v4_meta_bars_timeRemainingBarLabel.split("xx:xx")[1]}
              </span>
            </div>
          );
        }
        return null;
      })}
      {freeShippingApplied && freeShippingEnabled && (
        <div className="bars__bar_4">
          <TruckIcon />
          <span>
            {content?.tr_checkout_v4_meta_bars_free_shipping_expiration_label.split("xx:xx")[0]}
            <span className="bars__bar_3_clockTime">
              <Timer time={remainingTime} />
            </span>
            {content.tr_checkout_v4_meta_bars_free_shipping_expiration_label.split("xx:xx")[1]}
          </span>
        </div>
      )}
    </div>
  );
};

export default Bars;
